import React from "react";
import Button from "@mui/material/Button";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { NavigationEntry, navigationLinks, navigationSettingItems, nonAdminItems } from "./Navigation";
import usePermissions from "../permissions/usePermissions";
import { useTranslation } from "react-i18next";
import Box from "@mui/material/Box";
import NavigationDesktopButton from "./NavigationDesktopButton";
import { settingsSectionPermissions } from "../permissions/TaxGuruPermissionBuilder";
import Stack from "@mui/material/Stack";
import NavigationLogo from "./NavigationLogo";
import TaxGuruProfileIndicator from "./TaxGuruProfileIndicator";
import useMenuAnchorState from "../components/hook/useMenuAnchorState";
import CollapsedItemsMenu from "./menu/CollapsedItemsMenu";
import { useLocation } from "react-router-dom";
import useIAmAccountant from "../modules/accountant/function/useIAmAccountant";

const NavigationDesktopSmartButton = ({ item }: { item: NavigationEntry }) => {
    const { accountant } = useIAmAccountant();
    const { hasAtLeastOnePermissionOrEmpty } = usePermissions();
    if (!item?.divider) {
        const { link, title, permissionsAtLeastOne } = item;
        if (!hasAtLeastOnePermissionOrEmpty(permissionsAtLeastOne)) {
            return null;
        }
        if (link === navigationLinks.TAX_LICENCES_LINK && accountant?.licence?.id) {
            return <NavigationDesktopButton key={title} link={`${navigationLinks.TAX_LICENCES_LINK}/${accountant?.licence?.id}`} title={title} />;
        }
        return <NavigationDesktopButton key={title} title={title} link={link} />;
    }
    return null;
};

const NavigationDesktop = () => {
    const { hasAtLeastOnePermission } = usePermissions();
    const { t } = useTranslation();
    const location = useLocation();
    const { anchorEl: adminAnchorEl, onOpenMenu: onOpenAdminMenu, onCloseMenu: onCloseAdminMenu } = useMenuAnchorState();

    const currentSettingsItem = navigationSettingItems.find((item) => !item.divider && item.link && location.pathname.startsWith(item.link));

    const settingsButtonLabel = !currentSettingsItem?.divider
        ? currentSettingsItem?.title ?? t("navigation.settings").toString()
        : t("navigation.settings").toString();
    return (
        <Stack direction="row" alignItems="center">
            <Box sx={{ width: "160px" }}>
                <NavigationLogo />
            </Box>
            <Box sx={{ ml: 2 }}>
                <TaxGuruProfileIndicator />
            </Box>
            <Stack direction="row" spacing={2} sx={{ marginLeft: { md: 1, lg: 6 } }} alignItems="center">
                {nonAdminItems.map((item, index) => (
                    <NavigationDesktopSmartButton key={index} item={item} />
                ))}
                {hasAtLeastOnePermission(settingsSectionPermissions) && (
                    <Box>
                        <Button color="secondary" onClick={onOpenAdminMenu} endIcon={<KeyboardArrowDownIcon />} variant="outlined">
                            {settingsButtonLabel}
                        </Button>
                        <CollapsedItemsMenu
                            items={navigationSettingItems}
                            onOptionClick={onCloseAdminMenu}
                            onCloseMenu={onCloseAdminMenu}
                            anchorEl={adminAnchorEl}
                        />
                    </Box>
                )}
            </Stack>
        </Stack>
    );
};

export default NavigationDesktop;
